export default __webpack_public_path__ + "static/media/Solflare.55f577e7.svg";